export default "__VITE_ASSET__019449e9__"